// Sets per-page title + Open Graph tags (picked up by prerendering crawlers)
export const setPageMeta = ({ title, description, image }) => {
  if (title) document.title = title;
  const set = (attr, key, val) => {
    if (!val) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
    el.setAttribute("content", val);
  };
  const img = image && !image.startsWith("http") ? `${window.location.origin}${image}` : image;
  set("property", "og:title", title); set("name", "twitter:title", title);
  set("name", "description", description); set("property", "og:description", description); set("name", "twitter:description", description);
  set("property", "og:image", img); set("name", "twitter:image", img);
  set("property", "og:url", window.location.href);
};

// Link that shows a page-specific preview in WhatsApp etc., then opens `path`
export const shareLink = (path) => `${window.location.origin}/api/s${path.startsWith("/") ? path : `/${path}`}`;
